import React from "react";

const NotebookFrame1 = () => {
  return (
    <svg
      // width="auto"
      height="100%"
      viewBox="0 0 690 420"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M689.905 394.955L689.818 394.781L689.684 394.647L689.558 394.512L689.376 394.425L689.203 394.339H623.942C625.805 390.879 626.871 386.915 626.871 382.705V35.4913C626.871 21.9701 615.904 11 602.38 11H87.6198C81.1221 11 74.8929 13.5826 70.3058 18.1792C65.7109 22.7678 63.1292 28.9992 63.1292 35.4913V382.705C63.1292 386.915 64.195 390.879 66.0583 394.339H0.797405L0.576342 394.425L0.442125 394.512L0.268433 394.647L0.181587 394.781L0.0473706 394.955L0 395.136V400.041L0.0947412 400.222L0.228958 400.349L0.40265 400.483L1.15268 400.838L2.39221 401.328L4.16072 401.905L5.3134 402.213L6.63978 402.568L8.10037 402.963L9.8215 403.318L11.6768 403.713L13.8006 404.116L16.106 404.511L18.6719 404.953L21.4589 405.356L24.5064 405.751L27.8223 406.146L31.4541 406.588L35.299 406.944L39.4992 407.346L43.9678 407.702L48.7443 408.049L53.8761 408.365L59.3159 408.673L65.1109 408.934L71.2612 409.202L77.8062 409.423L84.7065 409.597L91.9621 409.731L99.6519 409.866L107.744 409.913L116.24 409.953H573.76L582.256 409.913L590.348 409.866L597.998 409.731L605.293 409.597L612.194 409.423L618.699 409.202L624.889 408.934L630.684 408.673L636.124 408.365L641.256 408.049L646.032 407.702L650.501 407.346L654.654 406.944L658.546 406.588L662.13 406.146L665.446 405.751L668.502 405.356L671.328 404.953L673.902 404.511L676.199 404.116L678.323 403.713L680.178 403.318L681.86 402.963L683.36 402.568L684.687 402.213L685.792 401.905L687.608 401.328L688.847 400.838L689.597 400.483L689.771 400.349L689.905 400.222L689.953 400.041L690 399.82V395.136L689.905 394.955V394.955ZM606.304 361.278C606.304 362.084 605.649 362.747 604.843 362.747H85.1565C84.3512 362.747 83.6959 362.084 83.6959 361.278V41.541C83.6959 41.1461 83.8459 40.7749 84.1223 40.4985C84.3986 40.2221 84.7697 40.072 85.1565 40.072H604.843C605.649 40.072 606.304 40.7276 606.304 41.541V361.278Z"
        fill="#191919"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M84.627 362.435C83.8148 362.435 83.1564 361.779 83.1564 360.971V42.1626C83.1564 41.7743 83.3113 41.402 83.5871 41.1275C83.8629 40.8529 84.237 40.6987 84.627 40.6987H605.373C606.185 40.6987 606.844 41.3541 606.844 42.1626V360.971C606.844 361.779 606.185 362.435 605.373 362.435H84.627Z"
        fill="white"
      />
      <mask
        id="mask0_2_5"
        // style="mask-type:alpha"
        maskUnits="userSpaceOnUse"
        x="83"
        y="40"
        width="524"
        height="323"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M84.627 362.435C83.8148 362.435 83.1564 361.779 83.1564 360.971V42.1626C83.1564 41.7743 83.3113 41.402 83.5871 41.1275C83.8629 40.8529 84.237 40.6987 84.627 40.6987H605.373C606.185 40.6987 606.844 41.3541 606.844 42.1626V360.971C606.844 361.779 606.185 362.435 605.373 362.435H84.627Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask0_2_5)">
        <rect x="70" y="31" width="550" height="44" fill="#E7E7E7" />
        <path d="M121 57H166" stroke="white" strokeWidth="5" />
      </g>
      <rect x="422" y="175" width="175" height="63" fill="#D9D9D9" />
      <rect x="480" y="81" width="117" height="63" fill="#D9D9D9" />
      <rect x="93" y="81" width="225" height="90" fill="#D9D9D9" />
      <rect x="93" y="176" width="225" height="45" fill="#D9D9D9" />
      <rect x="93" y="227" width="225" height="45" fill="#D9D9D9" />
      <rect x="93" y="277" width="225" height="45" fill="#D9D9D9" />
      <rect x="93" y="327" width="173" height="31" fill="#D9D9D9" />
      <rect x="484" y="295" width="117" height="63" fill="#D9D9D9" />
      <path
        d="M273 330H473M273 339H473M273 348H473M273 356H473"
        stroke="#E7E7E7"
        strokeWidth="5"
      />
      <path
        d="M396 249H597M396 260.769H597M396 272.538H597M396 283H597"
        stroke="#E7E7E7"
        strokeWidth="5"
      />
      <path d="M396 151H597M396 162.769H597" stroke="#E7E7E7" strokeWidth="5" />
      <path
        d="M325 84H473M325 96H473M325 108H473"
        stroke="#E7E7E7"
        strokeWidth="5"
      />
      <rect x="178" y="92" width="333" height="223" fill="#191919" />
      <circle cx="101" cy="57" r="8" fill="white" />
    </svg>
  );
};

export default NotebookFrame1;
